/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon64Regular = forwardRef('ArrowFigureACircleLeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M46.5 32a1.5 1.5 0 0 0-1.5-1.5H21.896l7.94-7.94a1.5 1.5 0 0 0-2.122-2.12l-8.378 8.378a4.5 4.5 0 0 0 0 6.364l8.378 8.379a1.5 1.5 0 0 0 2.122-2.122l-7.94-7.939H45a1.5 1.5 0 0 0 1.5-1.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M58 32C58 17.64 46.36 6 32 6S6 17.64 6 32s11.64 26 26 26 26-11.64 26-26ZM32 9c12.703 0 23 10.297 23 23S44.703 55 32 55 9 44.703 9 32 19.297 9 32 9Z" })));
});
